"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getAccountInfo = getAccountInfo;
exports.checkHasLogin = checkHasLogin;

_Object$defineProperty(exports, "refreshToken", {
  enumerable: true,
  get: function get() {
    return _qbJsapi.refreshToken;
  }
});

_Object$defineProperty(exports, "onLoginUserSwitch", {
  enumerable: true,
  get: function get() {
    return _qbJsapi.onLoginUserSwitch;
  }
});

_Object$defineProperty(exports, "AccountInfo", {
  enumerable: true,
  get: function get() {
    return _qbJsapi.AccountInfo;
  }
});

_Object$defineProperty(exports, "fetchSession", {
  enumerable: true,
  get: function get() {
    return _qbJsapi.fetchSession;
  }
});

_Object$defineProperty(exports, "callNativeWithPromise", {
  enumerable: true,
  get: function get() {
    return _qbJsapi.callNativeWithPromise;
  }
});

_Object$defineProperty(exports, "setStorage", {
  enumerable: true,
  get: function get() {
    return _qbJsapi.setStorage;
  }
});

_Object$defineProperty(exports, "getStorage", {
  enumerable: true,
  get: function get() {
    return _qbJsapi.getStorage;
  }
});

_Object$defineProperty(exports, "clearStroage", {
  enumerable: true,
  get: function get() {
    return _qbJsapi.clearStroage;
  }
});

_Object$defineProperty(exports, "AegisModule", {
  enumerable: true,
  get: function get() {
    return _qbJsapi.AegisModule;
  }
});

exports.getBrowserParam = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _qbJsapi = require("./platform/qbJsapi");

var _helper = require("./utils/helper");

var _log = require("./utils/log");

/**
 * 获取accountInfo，支持业务侧控制是否需要唤起登陆面板！!!!
 * @param opt
 */
function getAccountInfo(_x) {
  return _getAccountInfo.apply(this, arguments);
}

function _getAccountInfo() {
  _getAccountInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(opt) {
    var log, accountInfo;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log = new _log.Logger('getAccountInfoEnhanced');
            log.log('---start---');
            _context.next = 4;
            return (0, _qbJsapi.getAccountInfo)();

          case 4:
            accountInfo = _context.sent;

            if (!(!checkHasLogin(accountInfo) && opt !== null && opt !== void 0 && opt.isNeedLogin)) {
              _context.next = 9;
              break;
            }

            _context.next = 8;
            return (0, _qbJsapi.showQBLoginPanel)(opt === null || opt === void 0 ? void 0 : opt.loginParams);

          case 8:
            accountInfo = _context.sent;

          case 9:
            log.log('---end---', accountInfo);
            return _context.abrupt("return", accountInfo);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getAccountInfo.apply(this, arguments);
}

function checkHasLogin(accountInfo) {
  return (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.uin) && ((accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.token) || (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.skey));
}

var getBrowserParam = (0, _helper.withCache)(_qbJsapi.getBrowserParam);
exports.getBrowserParam = getBrowserParam;